import { render, staticRenderFns } from "./staffmembers.vue?vue&type=template&id=1d7edc81&"
import script from "./staffmembers.vue?vue&type=script&lang=js&"
export * from "./staffmembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports